/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
import {gsap} from 'gsap';
( function( app ) {
  const COMPONENT = {
    className: 'll-mpf',
    selector: function() {
      return '.' + this.className;
    },
    init: function() {
      // Animate MPF graphic
      const graphic = document.querySelector( 'img[src*="mpf-graphic.png"]' );
      if ( graphic ) {
        gsap.set( graphic, {
          transformOrigin: '50% 100%',
          scale: 0,
        } );

        gsap.to( graphic, {
          scale: 1,
          duration: 1,
          delay: 1,
          ease: 'power2.out',
        } );
      }

      // Hover state on radio labels
      $( '.ginput_container_radio' ).each( function() {
        const container = $( this );
        container.find( 'input[type="radio"]' ).each( function() {
          const input = $( this );
          const label = input.next( 'label' );
          const wrapper = container.find( '.gfield-choice-image-wrapper' );

          if ( label.length && wrapper.length ) {
            label
                .on( 'mouseenter focus', () => wrapper.addClass( 'hovered' ) )
                .on( 'mouseleave blur', () => wrapper.removeClass( 'hovered' ) );
          }
        } );
      } );

      // Back button rendering
      const backButton = document.querySelector( '.llgq-quoter-back' );
      if ( backButton && !backButton.classList.contains( 'has-svg' ) ) {
        backButton.classList.add( 'has-svg' );
        backButton.innerHTML = `
          <svg class="icon size-3 mr-3 icon-left-arrow" aria-hidden="true">
            <use xlink:href="#icon-left-arrow"></use>
          </svg>
          <span>Back</span>
        `;
      }

      // Handle checkboxes: sync .checked class (no localStorage)
      jQuery( document ).on( 'gform_post_render', function() {
        jQuery( 'input[type="checkbox"]' ).each( function() {
          const $input = jQuery( this );

          // Set class based on current state
          $input.toggleClass( 'checked', $input.prop( 'checked' ) );

          // Update class on change
          $input
              .off( 'change.checkedState' )
              .on( 'change.checkedState', function() {
                const isChecked = $input.prop( 'checked' );
                $input.toggleClass( 'checked', isChecked );
              } );
        } );
      } );

      // Style & format "Next" arrow buttons
      const arrowButtons = document.querySelectorAll( '.llgq-quoter-next' );
      arrowButtons.forEach( ( btn ) => {
        $( btn ).addClass( 'btn-primary-heritage' );
        const text = btn.innerHTML.trim();
        btn.innerHTML = `
          <span class="btn__text-wrapper">${text}</span>
          <span class="btn__icon-wrapper">
            <svg class="icon icon-right-arrow" aria-hidden="true">
              <use xlink:href="#icon-right-arrow"></use>
            </svg>
          </span>
        `;
      } );

      // Handle progress bar + submission logic
      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        const $submitBtn = $( '.ll-mpf-submit' );
        const $progressFill = document.querySelector( '.gf-progress-fill' );
        const totalSteps = document.querySelectorAll( '.gform_page' ).length;

        // Update progress bar starting at 15%
        if ( $progressFill && totalSteps > 1 ) {
          const basePercent = 15;
          const remainingPercent = 100 - basePercent;
          const percent = basePercent + ( ( currentPage - 1 ) / ( totalSteps - 1 ) ) * remainingPercent;
          $progressFill.style.width = `${percent}%`;
        }

        // Show/Hide fake submit and bind actual trigger
        if ( parseInt( currentPage ) === totalSteps ) {
          $submitBtn.removeClass( 'hidden' );

          $submitBtn
              .prop( 'disabled', false ) // make sure it's re-enabled
              .off( 'click.llsubmit' )
              .on( 'click.llsubmit', function() {
                const $this = $( this );
                if ( $this.prop( 'disabled' ) ) return;

                // Disable to prevent double click
                $this.prop( 'disabled', true );

                // Gravity Forms already handles submission; we just trigger the real submit button
                $( '.ll-submit' ).trigger( 'click' );
              } );
        } else {
          $submitBtn.addClass( 'hidden' ).prop( 'disabled', false );
        }
      } );
    },
    finalize: function() {},
  };

  app.registerComponent( 'll-mpf', COMPONENT );
} )( app );
